import { z } from 'zod';


export const progressivityFormSchema = z.object({
  startDate: z.string().min(1, 'attendance:configuration.workday.validation.startDateRequired'),
  weeklyHours: z.coerce
    .number({
      invalid_type_error: 'attendance:configuration.workday.validation.weeklyHoursRequired',
    })
    .int('attendance:configuration.workday.validation.weeklyHoursRequired')
    .positive('attendance:configuration.workday.validation.weeklyHoursPositive'),
});

export type ProgressivityFormValues = z.infer<typeof progressivityFormSchema>;
